<template>
    <div id="columnchartdiv" v-if="chartData"></div>													
</template>

<script>

import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
am4core.useTheme(am4themes_animated)
    
export default {
	name: 'column-chart',
	props: {
		chartData: Array,
	},

	data() {
		return {
			chart: null,
		}
	},

	mounted() {
		this.initialize()
	},

	methods: {

		initialize() {
			if (this.chart) {
				this.chart.dispose()
			}

			// Validate chart data
			if (!this.chartData || !Array.isArray(this.chartData) || this.chartData.length === 0) {
				return
			}

			this.chart = am4core.create('columnchartdiv', am4charts.XYChart)
			this.chart.data = this.chartData
			this.chart.height = 800

			let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
			categoryAxis.dataFields.category = 'name'
			categoryAxis.renderer.grid.template.location = 0
			categoryAxis.renderer.minGridDistance = 10
			categoryAxis.renderer.labels.template.horizontalCenter = 'right'
			categoryAxis.renderer.labels.template.verticalCenter = 'middle'
			categoryAxis.renderer.labels.template.rotation = 270
			categoryAxis.tooltip.disabled = true
			categoryAxis.fontSize = 11

			let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis())
			valueAxis.renderer.minWidth = 40
			valueAxis.title.text = 'Quantità'

			// Create series
			let series = this.chart.series.push(new am4charts.ColumnSeries())
			series.sequencedInterpolation = true
			series.dataFields.valueY = 'quantity'
			series.dataFields.categoryX = 'name'
			series.columns.template.tooltipText = '[font-size:12px]{categoryX}: {valueY}'

			series.columns.template.strokeWidth = 0

			series.tooltip.pointerOrientation = 'vertical'

			// Add label
			let labelBullet = series.bullets.push(new am4charts.LabelBullet())
			labelBullet.label.text = '{valueY}'
			labelBullet.fontSize = 8
			labelBullet.locationY = 0

			series.columns.template.column.cornerRadiusTopLeft = 10
			series.columns.template.column.cornerRadiusTopRight = 10
			series.columns.template.column.fillOpacity = 0.8

			// on hover, make corner radiuses bigger
			let hoverState = series.columns.template.column.states.create('hover')
			hoverState.properties.cornerRadiusTopLeft = 0
			hoverState.properties.cornerRadiusTopRight = 0
			hoverState.properties.fillOpacity = 1

			series.columns.template.adapter.add('fill', (fill, target) => {
				return this.chart.colors.getIndex(target.dataItem.index)
			})

			// Cursor
			this.chart.cursor = new am4charts.XYCursor()
            
			// Enable export menu
			this.chart.exporting.menu = new am4core.ExportMenu()
			this.chart.exporting.menu.items = [{
				label: "...",
				menu: [
					{ type: "png", label: "PNG" },
					{ type: "jpg", label: "JPG" },
					{ type: "csv", label: "CSV" },
					{ type: "xlsx", label: "XLSX" },
					{ type: "pdf", label: "PDF" }
				]
			}]

			this.chart.scrollbarX = new am4core.Scrollbar()
			this.chart.scrollbarX.marginBottom = 25


		},
	},

	beforeDestroy() {
		if (this.chart) {
			this.chart.dispose()
		}
	},

	watch: {
		chartData: {
			handler() {
				this.initialize()
			},
			deep: true
		},
	}
}
</script>

<style>
	g[opacity|="0.4"][aria-labelledby|="id"] {
  		display: none;
	}
    
    #columnchartdiv {
        min-height: 800px
    }
</style>
